<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.1073 14.6569L25.1652 16.2269C23.3886 19.1881 20.1885 20.9999 16.7353 20.9999C13.282 20.9999 10.082 19.1881 8.3053 16.2269L7.36328 14.6569L9.07827 13.6279L10.0203 15.198C11.4355 17.5567 13.9845 18.9999 16.7353 18.9999C19.486 18.9999 22.035 17.5567 23.4503 15.198L24.3923 13.6279L26.1073 14.6569Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.7216 22.9823L17.4955 20.4334L19.2978 19.5664L20.5239 22.1153L18.7216 22.9823Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.7489 22.9823L15.975 20.4334L14.1727 19.5664L12.9466 22.1153L14.7489 22.9823Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.0282 20.707L21.0282 18.707L22.4424 17.2928L24.4424 19.2928L23.0282 20.707Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.4424 20.707L12.4424 18.707L11.0281 17.2928L9.02814 19.2928L10.4424 20.707Z"
        />
    </svg>
</template>
